export default () => ({
  authUser: null,
  claims: null,
  userDoc: null,
  subscriptionDoc: null,
  showUpgradeModal: false,
})
